/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import { Spacer, Button, Checkbox } from '@cleartrip/bento'
import { resolveKeysInObjectsArrays, onlyNumbersRegex } from 'AccountsUtils'
import { sendOtpForSignIn } from '../../../pages/Trips/trips.helper'
import { errorConfig } from './errorConfig'
import Field from '../../../components/Form'
import useModal from '../../../newComponents/SupportPage/useModal'

const LoginWithMobileMLP2 = ({
  setPageName,
  validateMobileHandler,

  countryCode,
  setIsGOpaque = () => { },
  setIsPOpaque = () => { },
  setIsNumberEditable = () => { },
  setIsEOpaque = () => { },
  isNumberEditable,
  userNumber,

  setUserNumber = () => { }
}) => {
  const animationDefaultState = {
    isAnimate: false,
    direction: 'right',
    isFadeIn: false
  }

  const [loading, setLoading] = useState(false)
  const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', ''])
  const [apiError, setApiError] = useState('')

  const { isShowing, toggle } = useModal()

  const getOtpValue = () => {
    const otp = otpDigits.join('')
    return otp
  }

  const disabled = getOtpValue().length != 6
  const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)

  const handleCancel = () => {
    toggle()
    setIsNumberEditable(true)
    setIsGOpaque(false)
    setIsPOpaque(false)
    setIsEOpaque(false)
  }
  const getOtp = async () => {
    setLoading(true)
    setApiError('')
    const mobileValid = validateMobileHandler()

    try {
      if (mobileValid) {
        const payload = {
          type: 'MOBILE',
          value: userNumber,
          countryCode,
          action: 'UPDATE_MOBILE'
        }
        const response = await sendOtpForSignIn(payload)
        const { status, data, error } = response || {}
        if (status === 202) {
          const { action } = data || {}
          setPageName('VERIFY_MOBILE_NUMBERML')
        } else {
          const { response = { data: {} } } = error || {}
          const { data = {} } = response
          const { message } = data
          const errRes = errorConfig[message] || errorConfig.default

          setApiError(errRes)
        }
        setLoading(false)
      } else {
        setApiError('Please enter a valid mobile number')
      }
    } catch (e) {
      setApiError('Something went wrong')
      console.log('otp api error', e)
    }
    setLoading(false)
  }
  const handleMobileNumberChange = e => {
    setApiError('')
    let num = e.target.value
    if (onlyNumbersRegex.test(num) || num === '') {
      setUserNumber(num)
    }
  }

  return (
    <div className="flex flex-column">
      <span className=" fw-600 fs-16 mt-6 mb-5">Edit Mobile number</span>

      <div className="flex flex-column">
        <div className="flex flex-row">
          <Field
            label="Phone Number"
            type="tel"
            pattern="[0-9]"
            wrapperClassName="mb-5 w-328"
            onChange={handleMobileNumberChange}
            value={userNumber}
            // onBlur={validateMobile}
            // value={data?.phone || ''}
            // hasError={errors.phone ? true : false}
            // errorMessage={errors.phone}
            hideLabel={true}
            // hasError={hasError}
            isMobileNumberField={true}
            // onFocus={onFocus}
            maxLength="10"
          />

          {/* <input
            type="text"
            maxLength="10"
            wrapperClassName="w-270  h-56 "
            placeholder="Mobile number"
            style={{ border: '1px solid #E7E7E7', borderRadius: '6px' }}
            className="fs-4 fw-500"
            value={userNumber}
            onChange={e => {
              setUserNumber(e.target.value)
            }}
          /> */}
        </div>

        {apiError && (
          <div className="fw-500 fs-12 lh-16 mt-2" style={{ color: '#CC1414' }}>
            {apiError}
          </div>
        )}

        <div className="flex flex-row">
          <Button
            className="h-10 w-170 br-6-imp"
            disabled={!disabled}
            size="lg"
            type="secondary"
            busy={loading}
            onClick={() => getOtp()}
          >
            <span className={`${!disabled ? 'c-grey-30' : ''} fs-3 fw-500 `}>
              Confirm and verify
            </span>
          </Button>
          <a onClick={handleCancel} className="fw-600 fs-14 lh-20 ml-12 mt-2">
            Cancel
          </a>
        </div>
        <Spacer className="mt-5" />
      </div>
    </div>
  )
}

export default LoginWithMobileMLP2
